import G6 from '../../../topology/src/scripts/core';

/**
 * 拓扑插件-对外暴露工具类
 * @type util 工具类
 */
export const graphUtil = G6.Util;
